import {
  RingProgressProps as MantineRingProgressProps,
  RingProgress as MantineRingProgress,
} from '@mantine/core';

export type RingProgressProps = MantineRingProgressProps;

export const RingProgress = MantineRingProgress;

RingProgress.displayName = 'RingProgress';
